import { CategoriesSlide } from 'components';

export const CategoriesMenu = ({ close }) => {
  return (
    <div className="wrapper-lg py-12">
      <CategoriesSlide close={close}/>
    </div>
  );
};
